<template>
  <v-row
    class="fill-height px-10"
    align="center"
    justify="center"
  >
    <v-col>
      <a
        :href="appUrl"
        target="_blank"
        ><img
          alt="app-logo"
          height="70px"
          :src="appLogo"
      /></a>

      <h2 class="font-weight-light my-5">{{ $t("views.personal_settings.reset_pwd_title") }}</h2>
      <span class="mt-5">{{ $t("views.personal_settings.reset_pwd_subtitle") }}</span>
      <v-form
        ref="form"
        v-model="isFormValid"
      >
        <v-text-field
          clearable
          :append-icon="showPassword.password1 ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append="showPassword.password1 = !showPassword.password1"
          :type="showPassword.password1 ? 'text' : 'password'"
          :rules="rules.password1"
          v-model="resetForm.password1"
          :label="$t('views.personal_settings.new_pwd')"
        />
        <v-text-field
          clearable
          :append-icon="showPassword.password2 ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append="showPassword.password2 = !showPassword.password2"
          :type="showPassword.password2 ? 'text' : 'password'"
          :rules="rules.password2"
          v-model="resetForm.password2"
          :label="$t('views.personal_settings.repeat_pwd')"
          @keyup.enter="submit"
        />
      </v-form>
      <div class="d-flex justify-center">
        <v-btn
          block
          style="width: 50%"
          large
          @click="submit"
          @keyup.enter="submit"
          class="mb-3 mt-5 d-block"
          :disabled="loading"
          :loading="loading"
          color="blue white--text"
          >{{ $t("views.personal_settings.reset_pwd") }}</v-btn
        >
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { AccountService } from "@/services"
import { password, required } from "@/utils/validator"

export default {
  name: "ResetPassword",
  data: function () {
    return {
      appLogo: this.$appConfig.assets.img.custom.logo,
      appUrl: this.$appConfig.url,
      isFormValid: true,
      showPassword: {
        password1: false,
        password2: false
      },
      resetForm: {
        password1: "",
        password2: ""
      },
      loading: false,
      rules: {
        password1: [required, password],
        password2: [
          required,
          v => v === this.resetForm.password1 || this.$t("views.invalid_invitation.repeat_same_pwd")
        ]
      }
    }
  },
  methods: {
    submit() {
      if (this.loading) return
      this.$refs.form.validate()
      this.$nextTick(() => {
        if (this.isFormValid) {
          this.loading = true
          AccountService.sendNewPassword(
            this,
            this.resetForm.password1,
            this.resetForm.password2,
            this.$route.params.uid,
            this.$route.params.key
          )
        }
      })
    }
  }
}
</script>
